module.exports = __webpack_public_path__ + "static/media/flatsO.58e9c049.png";